import React, { useEffect, useState } from "react";
import {
  Segment,
  Tab,
  TabPane,
} from "semantic-ui-react";
import iconEnergia from "../../../../assets/svg/Capa 4.svg";
import iconCombustibles from "../../../../assets/svg/Capa 5.svg";
import iconAgua from "../../../../assets/svg/Capa 6.svg";
import iconEfluentes from "../../../../assets/svg/Rectangle 184.svg";
import iconResiduos from "../../../../assets/svg/Group.svg";
import iconSocial from "../../../../assets/svg/Capa 1.svg";
import iconGEI from "../../../../assets/svg/GroupGei.svg";
import { Line, Pie, Column } from "@ant-design/charts";
import { Link, useLocation } from "react-router-dom";
import { Permission, Productionform, Socialform, Site } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./Dashboard.scss";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { WaterKPIsDashBoard } from "../WaterKPIsDashboard/WaterKPIsDashBoard";
import { useSite } from "../../../../contexts";
import { EnergyKPIsDashBoard } from "../EnergyKPIsDashboard";
import { WasteKPIsDashBoard } from "../WasteKPIsDashboard";
//import { ObjectivesAndBaseline } from "../ObjectivesAndBaseline/ObjectivesAndBaseline";
import { EffluentKPIsDashBoard } from "../EffluentKPIsDashboard";
import { AirEmissionsKPIsDashBoard } from "../AirEmissionsKPIsDashboard/AirEmissionsKPIsDashBoard";
import { SocialKPIsDashBoard } from "../SocialKPIsDashboard";
import { FuelsKPIsDashBoard } from "../FuelsKPIsDashboard/FuelsKPIsDashBoard";
import { useCompany } from "../../../../contexts/CompanyContext";
import { EmissionsSummaryDashboard } from "../EmissionsSummaryDashboard/EmissionsSummaryDashBoard";

import { GEIDashBoard } from "../GEIDashboard/GEIDashBoard";
import { GeneralDashboard } from "../GeneralDashboard/GeneralDashboard";
import iconInicio from "../../../../assets/svg/isosustemia 1.svg";
const permissionController = new Permission();
const productionController = new Productionform();
const socialController = new Socialform();
const siteController = new Site();

export function DashBoard(props) {
  const { siteSelected, companySelected } = props;
  const { company: companyCtx } = useCompany();

  const { pathname } = useLocation();
  const {
    user: { role },
    accessToken,
  } = useAuth();

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const [permissionActive, setPermissionsActive] = useState([]);
  const [sharedProductionForms, setSharedProductionForms] = useState(null);
  const [sharedWorkersByPeriod, setSharedWorkersByPeriod] = useState(null);
  const [siteName, setSiteName] = useState("");

  const [zoom, setZoom] = useState(() => {
    const saved = localStorage.getItem("dashboard_zoom");
    return saved ? Number(saved) : 70;
  });

  useEffect(() => {
    const onZoom = (e) => setZoom(e.detail);
    window.addEventListener("dashboard-zoom-change", onZoom);
    return () => window.removeEventListener("dashboard-zoom-change", onZoom);
  }, []);

  // El sitio activo lo define exclusivamente el selector del header
  // (siteSelected / useSite()): así, elegir "Total grupo" colapsa a la
  // pestaña Inicio incluso para usuarios que tienen un sitio de sesión fijo.
  const currentSite = siteSelected;
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  useEffect(() => {
    // Solo resetear a Inicio cuando no hay sitio seleccionado
    if (!currentSite) setActiveTabIndex(0);
  }, [currentSite]);

  useEffect(() => {
    if (!currentSite) return;
    (async () => {
      try {
        const currentYear = new Date().getFullYear();
        const lastFiveYears = Array.from({ length: 5 }, (_, i) => String(currentYear - i));
        const [prodResponse, workersResponse] = await Promise.all([
          productionController.getProductionFormsBySiteAndYears(accessToken, currentSite, lastFiveYears),
          socialController.getTotalWorkersByYearsAndPeriod(accessToken, currentSite, lastFiveYears),
        ]);
        setSharedProductionForms(prodResponse.productionForms);
        setSharedWorkersByPeriod(workersResponse.totalWorkersByPeriod);
      } catch (error) {
        console.error("Error fetching shared dashboard data:", error);
      }
    })();
  }, [currentSite, accessToken]);

  useEffect(() => {
    if (!currentSite) { setSiteName(""); return; }
    (async () => {
      try {
        const siteData = await siteController.getSite(accessToken, currentSite);
        setSiteName(siteData?.name || "");
      } catch {
        setSiteName("");
      }
    })();
  }, [currentSite, accessToken]);

  const isCurrentPath = (path) => {
    if (path === pathname) return true;
    return false;
  };

  useEffect(() => {
    (async () => {
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsActive(response);
        }
      } catch (error) {
        //console.error(error);
        setPermissionsActive([]);
      }
    })();
  }, [role]);
useEffect(() => {
 // console.log("Dashboard montado");
}, []);

const getAbbreviation = (key, t) => {
  const word = t(key);
  return word.slice(0, 2).toUpperCase();
};


  const inicioPane = {
    menuItem: {
      key: "inicio",
      content: (
        <div className="tab-item">
          <img src={iconInicio} alt="inicio" className="tab-item__icon" />
          <span className="tab-item__label">{t("home") || "Inicio"}</span>
        </div>
      ),
    },
    render: () => (
      <Tab.Pane attached={false}>
        <GeneralDashboard company={companyCtx} site={currentSite} />
      </Tab.Pane>
    ),
  };

  const sitePanes = [
    {
      menuItem: {
        key: "energy",
        content: (
          <div className="tab-item">
            <img src={iconEnergia} alt="energia" className="tab-item__icon" />
            <span className="tab-item__label">{t("energy")}</span>
          </div>
        ),
      },
      render: () => (
        <Tab.Pane attached={false}>
          <EnergyKPIsDashBoard key={currentSite} site={currentSite} sharedProductionForms={sharedProductionForms} sharedWorkersByPeriod={sharedWorkersByPeriod} siteName={siteName} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: {
        key: "fuels",
        content: (
          <div className="tab-item">
            <img src={iconCombustibles} alt="combustibles" className="tab-item__icon" />
            <span className="tab-item__label">{t("fuels")}</span>
          </div>
        ),
      },
      render: () => (
        <TabPane attached={false}>
          <FuelsKPIsDashBoard key={currentSite} site={currentSite} sharedProductionForms={sharedProductionForms} sharedWorkersByPeriod={sharedWorkersByPeriod} siteName={siteName} />
        </TabPane>
      ),
    },
    {
      menuItem: {
        key: "water",
        content: (
          <div className="tab-item">
            <img src={iconAgua} alt="agua" className="tab-item__icon" />
            <span className="tab-item__label">{t("water")}</span>
          </div>
        ),
      },
      render: () => (
        <TabPane attached={false}>
          <WaterKPIsDashBoard key={currentSite} site={currentSite} sharedProductionForms={sharedProductionForms} sharedWorkersByPeriod={sharedWorkersByPeriod} siteName={siteName} />
        </TabPane>
      ),
    },
    {
      menuItem: {
        key: "effluent",
        content: (
          <div className="tab-item">
            <img src={iconEfluentes} alt="efluentes" className="tab-item__icon" />
            <span className="tab-item__label">{t("effluent")}</span>
          </div>
        ),
      },
      render: () => (
        <TabPane attached={false}>
          <EffluentKPIsDashBoard key={currentSite} site={currentSite} sharedProductionForms={sharedProductionForms} sharedWorkersByPeriod={sharedWorkersByPeriod} siteName={siteName} />
        </TabPane>
      ),
    },
    {
      menuItem: {
        key: "waste",
        content: (
          <div className="tab-item">
            <img src={iconResiduos} alt="residuos" className="tab-item__icon" />
            <span className="tab-item__label">{t("waste")}</span>
          </div>
        ),
      },
      render: () => (
        <TabPane attached={false}>
          <WasteKPIsDashBoard key={currentSite} site={currentSite} sharedProductionForms={sharedProductionForms} siteName={siteName} />
        </TabPane>
      ),
    },
    {
      menuItem: {
        key: "social",
        content: (
          <div className="tab-item">
            <img src={iconSocial} alt="social" className="tab-item__icon" />
            <span className="tab-item__label">{t("social")}</span>
          </div>
        ),
      },
      render: () => (
        <TabPane attached={false}>
          <SocialKPIsDashBoard key={currentSite} site={currentSite} sharedProductionForms={sharedProductionForms} sharedWorkersByPeriod={sharedWorkersByPeriod} siteName={siteName} />
        </TabPane>
      ),
    },
    {
      menuItem: {
        key: "gei",
        content: (
          <div className="tab-item">
            <img src={iconGEI} alt="GEI" className="tab-item__icon" />
            <span className="tab-item__label">{t("GEI")}</span>
          </div>
        ),
      },
      render: () => (
        <TabPane attached={false}>
          <GEIDashBoard key={currentSite} site={currentSite} siteName={siteName} />
        </TabPane>
      ),
    },
  ];

  const panes = currentSite ? [inicioPane, ...sitePanes] : [inicioPane];

  const subPanes = [
    {
      menuItem: "Overview",
      render: () => (
        <TabPane attached={false}>
          {" "}
          <Grid columns={2}>
            <GridColumn>
              <Line {...config} />
            </GridColumn>
            <GridColumn>
              <Line {...config} />
            </GridColumn>
          </Grid>{" "}
        </TabPane>
      ),
    },
    {
      menuItem: "Energia",
      render: () => (
        <TabPane attached={false}>
          <Pie {...config2} />
        </TabPane>
      ),
    },
    {
      menuItem: "Combustible",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
    {
      menuItem: "Agua",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
    {
      menuItem: "Efluentes",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
    {
      menuItem: "Residuos",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
    {
      menuItem: "Peligrosos",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
    {
      menuItem: "Social",
      render: () => (
        <TabPane attached={false}>
          <Column {...config3} />
        </TabPane>
      ),
    },
  ];

  const data = [
    { year: "1991", value: 3 },
    { year: "1992", value: 4 },
    { year: "1993", value: 3.5 },
    { year: "1994", value: 5 },
    { year: "1995", value: 4.9 },
    { year: "1996", value: 6 },
    { year: "1997", value: 7 },
    { year: "1998", value: 9 },
    { year: "1999", value: 13 },
  ];

  const config = {
    data,
    height: 400,
    xField: "year",
    yField: "value",
  };

  const config2 = {
    data: [
      { type: "opcion 1", value: 27 },
      { type: "opcion 2", value: 25 },
      { type: "opcion 3", value: 18 },
      { type: "opcion 4", value: 15 },
      { type: "opcion 5", value: 10 },
      { type: "opcion 6", value: 5 },
    ],
    angleField: "value",
    colorField: "type",
    label: {
      text: "value",
      style: {
        fontWeight: "bold",
      },
    },
    legend: {
      color: {
        title: false,
        position: "right",
        rowPadding: 5,
      },
    },
  };

  const data2 = [0.16, 0.125, 0.24, 0.19, 0.22, 0.05, 0.01, 0.015];

  const config3 = {
    data: data2.map((value) => ({
      index: value.toString(),
      value,
    })),
    xField: "index",
    yField: "value",
  };

  return (
    <>
     {/* <Segment textAlign="center" style={{
    borderRadius: "12px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
  }}>
        <Header as="h1">
          {t("WELCOME")} {useAuth().user.email}
        </Header>
      </Segment> */}
      {companyCtx && companyCtx !== "0" && companyCtx !== 0 ? (
        <>
          <div className="tab-container" style={{ zoom: zoom / 100 }}>
            <Tab
              key={currentSite || "general"}
              menu={{
                color: "blue",
                borderless: true,
                attached: false,
                tabular: false,
                style: {
                  background: "transparent",
                  boxShadow: "none",
                  border: "none",
                  padding: "0",
                },
                className: "custom-tab-menu"
              }}
              panes={panes}
              activeIndex={activeTabIndex}
              onTabChange={(_, { activeIndex }) => setActiveTabIndex(activeIndex)}
            />
          </div>
        </>
      ) : (
        <Segment></Segment>
      )}
    </>
  );
}

